export const ADD_PAYMENT_INSTRUMENT = 'ADD_PAYMENT_INSTRUMENT';
export const CAMPAIGN_TRACKING_COOKIE = 'campaign_tracking';
export const CREATE_INTENT_EVENT = 'createIntentEvent';
export const ENROLLMENT = 'ENROLLMENT';
export const LOGIN = 'LOGIN';
export const SET_INTENT = 'SET_INTENT';
export const UPDATE_INTENT = 'UPDATE_INTENT';
export const VMORC = 'iscAuthEnabled';
